import { Box } from '@mui/material';
import { CurrencyBanner } from '../ui/CurrencyBanner';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CurrencyBanner />
      <Header />
      <Box component="main" sx={{ flex: 1, overflowX: 'clip', width: '100%' }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}
